// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__15e3h","more":"styles_more__3CBLH"};